import { useStyles } from "./Profile.style";
import { ProfileInfo } from "../../components/common/ProfileInfo";
import { useEffect, useState } from "react";
import {
  getConfigGQL,
  getUserProfileTgpGQL,
  meGQL,
  CoinType,
  getStrangeProfileTgpGQL,
} from "@onmo/graphql/graphql";
import { useQuery } from "@apollo/client";
import { Query } from "@onmo/graphql/graphql";
import { ProfileAchievement } from "../../components/common/ProfileAchievement";
import { User } from "../../models/user";
import { useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Typography } from "../../components/core/Typography/Typography";
import { TypographyVariant } from "../../constants/typography";
import { USER_PROFILE_TABS } from "../../constants/userProfile";
import { StaticImage } from "../../components/common/StaticImage";
import VodaBucksIcon from "../../assets/image/vodabucks_1x.webp";
import VodaBucksIcon2x from "../../assets/image/vodabucks_2x.webp";
import VodaBucksIcon3x from "../../assets/image/vodabucks_3x.webp";
import ProfileActivity from "../../components/common/ProfileActivity/ProfileActivity";
import { ProfileStats } from "../../components/common/ProfileStats";
import { PRODUCT_QUERY } from "../../constants/achievement";

const profileTabList = [
  "tab_Stats",
  "tab_Achievements",
  "tab_VodaBucks",
  "tab_Recent Activities",
];

const Profile: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState(profileTabList[0]);
  const { userId: userIdParam }: { userId?: string } = useParams();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  const { data: dataMe } = useQuery<Query>(meGQL);
  const { data: dataConfig } = useQuery(getConfigGQL);
  const { data: dataProfile } = useQuery<{ user: Query["user"] }>(
    userIdParam ? getStrangeProfileTgpGQL : getUserProfileTgpGQL,
    {
      variables: {
        id: userIdParam || dataMe?.me.id,
        achievementsInput: { products: PRODUCT_QUERY },
        transactionsInput: { coinTypes: CoinType.GzTokens },
      },
      fetchPolicy: "cache-and-network",
    },
  );

  const userRank = User.getCurrentRank(
    dataMe?.me?.coinWallets,
    dataConfig?.config.tierLevels,
  );
  const gzTokens = User.getGzCoin(dataMe?.me?.coinWallets || []);

  useEffect(() => {
    if (tab === USER_PROFILE_TABS.stats) {
      setActiveTab(profileTabList[0]);
    } else if (tab === USER_PROFILE_TABS.achievements) {
      setActiveTab(profileTabList[1]);
    } else if (tab === USER_PROFILE_TABS.vodaBucks) {
      setActiveTab(profileTabList[2]);
    }
  }, [tab]);

  return (
    <div className={classes.root}>
      {userRank && (
        <ProfileInfo
          listTabs={profileTabList}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          profile={dataProfile?.user}
          userRank={userRank}
          gzTokens={gzTokens}
        />
      )}
      {activeTab.includes("Stats") && !userIdParam && dataMe?.me && (
        <ProfileStats
          profile={dataProfile?.user}
          wallet={dataMe?.me.coinWallets}
          rewardsHistory={dataProfile?.user?.transactions?.items}
        />
      )}
      {activeTab.includes("Recent") && !userIdParam && dataMe?.me && (
        <ProfileActivity me={dataMe?.me} />
      )}
      {(activeTab.includes("Achievements") || !!userIdParam) && (
        <ProfileAchievement
          achievements={dataProfile?.user?.achievements?.items}
        />
      )}
      {activeTab.includes("VodaBucks") && (
        <div className={classes.profileStat}>
          <div className={classes.card}>
            <div className={classes.cardLeft}>
              <Typography variant={TypographyVariant.BodyB6Medium}>
                Total Vodabucks
              </Typography>
              <Typography variant={TypographyVariant.BodyB1Bold}>0</Typography>
            </div>
            <StaticImage
              src={VodaBucksIcon}
              src2x={VodaBucksIcon2x}
              src3x={VodaBucksIcon3x}
              alt="VodaBucks"
              width={48}
              height={48}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
